import { FontSizes, makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  searchContainer: {
    backgroundColor: theme.palette.neutralLighter,
    height: 50,
    alignItems: 'center',
    padding: '0px 20px 0px 15px',
    marginBottom: 8,
    borderRadius: 4,
  },

  iconButtonColor: {
    color: theme.palette.neutralDark,
  },

  logoContainer: {
    height: 60,
    width: '100vw',
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
  },

  logoText: {
    color: theme.palette.neutralPrimary,
    paddingLeft: 6,
    marginBottom: -2,
  },

  globeStyleIcon: {
    padding: 10,
    fontSize: FontSizes.size14,
    color: 'white',
  },
  globeStyleIconDisable: {
    padding: 10,
    fontSize: FontSizes.size14,
    color: 'grey',
  },

 globalSearchStyle: {
  backgroundColor: theme.palette.themePrimary,
  color: 'white',
  borderRadius: 5,
  selectors: {
    ':hover': {
      backgroundColor: theme.palette.themeDarkAlt,
      cursor: 'pointer',
    },
  },
},

globalSearchStyleDisable: {
  backgroundColor: theme.palette.neutralQuaternaryAlt,
  color: 'white',
  borderRadius: 5,
  selectors: {
    ':hover': {
      backgroundColor: theme.palette.neutralQuaternary,
      cursor: 'pointer',
    },
  },
},
  iconBlueStyles: {
    selectors: {
      ':hover': {
        borderRadius: 2,
        backgroundColor: theme.palette.neutralLight,
      },
    },
  },

  textDecoder: {
    textDecoration: 'none',
  },
}));
